import BackButton from "components/Button/BackButton"
import { useEffect, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"
import { Domain, EmptyString, FormTypeAdd } from "utils/Constant"
import { FormCard, GridDeleteButton, GridEditButton, MainBodyCard, PagesFormTitle } from "components/Cards"
import { useModal } from "utils/context/ModalContext"
import { useCallApi } from "api/apiHooks"
import imageCompression from "browser-image-compression";
import { CustomerCardService } from "services/CustomerCardService/CustomerCardService"
import DataTable from "components/DataTable"
import { addSpaceEvery4, GetStatus } from "utils/helpers"

export default function CustomerView(){
    const navigate = useNavigate()

    const webcamRef = useRef(null)
    const { fetchInsertCustomer, fetchUpdateCustomer, fetchCustomerById, fetchDeleteCustomer} = useCallApi()
    const { fetchCustomerCardListByCustomerId } = CustomerCardService()
    const { fetchDeleteCustomerCard } = CustomerCardService()
    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()

    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let paramCustomerId = queryString.get("customerId")

    const [customerName, setCustomerName] = useState(EmptyString)
    const [address, setAddress] = useState(EmptyString)
    const [phone, setPhone] = useState(EmptyString)
    const [idPhoto, setIdPhoto] = useState(null)
    const [idPhotoPreview, setIdPhotoPreview] = useState('')
    const [masterMdrGestun, setMasterMdrGestun] = useState(EmptyString)
    const [masterMdrPl, setMasterMdrPl] = useState(EmptyString)
    const [masterMdrPlQris, setMasterMdrPlQris] = useState(EmptyString)
    const [createDate, setCreateDate] = useState(EmptyString)
    const [status, setStatus] = useState(EmptyString)
    const [updateDate, setUpdateDate] = useState(EmptyString)
    const [updateBy, setUpdateBy] = useState(EmptyString)

    const [customerCardList, setCustomerCardList] = useState([])
    
    const columns = [
        {
            key: "rowNumber",
            header: "No",
            headerClassName: "w-16 font-semibold",
            cellClassName: "text-center"
        },
        {
            key: "customerName",
            header: "Nama Pelanggan"
        },
        {
            key: "bankCode",
            header: "Bank",
            render: (row) => row.bankCode + ' - ' + row.cardVendorName,
        },
        {
            key: "cardNumber",
            header: "No Kartu",
            render: (row) => addSpaceEvery4(row.cardNumber),
        },
        {
            key: "mdr",
            header: "MDR",
        },
        {
            key: "status",
            header: "Status",
            render: (row) => GetStatus(row.status),
        },
        {
            key: "action",
            header: "Action",
            render: (row) => (
                <div className="flex gap-2">
                    <GridEditButton isActive={row.status} onClick={() => editBtnClick(row.customerCardId)} size="w-3" />
                    <GridDeleteButton isActive={row.status} onClick={() => deleteBtnClick(row.customerCardId, row.status)} size="w-3" />
                </div>
            ),
        },
    ]

    // Button Event
    const backBtnClick = () => {
        navigate('/customer')
    }
    const editBtnClick = (customerCardId) => {
        navigate("/customer-card/form?customerCardId=" + customerCardId + "&formType=Edit")
    }
    const deleteBtnClick = async (customerCardId, status) => {
        const isConfirmed = await confirm()

        if (isConfirmed) {
            showLoading()

            const res = await fetchDeleteCustomerCard(customerCardId, status)
            if (!res) return

            await getCustomerCardListByCustomerId()

            showSuccess()
        }
    }

    const getCustomerById = async () => {
        const res = await fetchCustomerById(paramCustomerId)
        if (!res) return false

        const data = res.data
        
        setCustomerName(data.customerName)
        setAddress(data.address)
        setPhone(data.phone)
        setIdPhotoPreview(Domain + '/images/' + data.fileName + `?t=${Date.now()}`)
        setMasterMdrGestun(data.masterMdrGestun)
        setMasterMdrPl(data.masterMdrPl)
        setMasterMdrPlQris(data.masterMdrPlQris)
        setStatus(data.status)
        setCreateDate(data.createDate)
        setUpdateDate(data.updateDate)
        setUpdateBy(data.updateBy)

        return true
    }
    const getCustomerCardListByCustomerId = async () => {
        const res = await fetchCustomerCardListByCustomerId(paramCustomerId)
        if (!res) return false

        setCustomerCardList(res)

        return true
    }

    useEffect(() => {
        const loadCustomer = async () => {            
            showLoading()

            try{
                await getCustomerById()
                await getCustomerCardListByCustomerId() 
            } finally{
                hideLoading()
            }
        }
        
        loadCustomer()
    }, [])

    return (
        <MainBodyCard>
            <PagesFormTitle 
                title='Detail Pelanggan'
                formType={formType}
                status={status}
                createDate={createDate}
                updateDate={updateDate}
                updateBy={updateBy}
            />

            <div className="mt-5 flex flex-col">
                <FormCard title='Nama Pelanggan'>
                    <label>{customerName}</label>
                </FormCard>

                <FormCard title='Alamat'>
                    <label>{address}</label>
                </FormCard>

                <FormCard title='No HP'>
                    <label>{addSpaceEvery4(phone)}</label>
                </FormCard>

                <FormCard title='MDR Gestun'>
                    <label>{masterMdrGestun}</label>
                </FormCard>

                <FormCard title='MDR PL'>
                    <label>{masterMdrPl}</label>
                </FormCard>

                <FormCard title='MDR PL QRIS'>
                    <label>{masterMdrPlQris}</label>
                </FormCard>

                <div className="flex flex-col sm:flex-row sm:items-center text-sm">
                    <div className="w-48">
                        <span>Photo ID</span>
                    </div>
                    <div className="px-4 hidden sm:block">
                        <span>:</span>
                    </div>
                    <div className="w-full sm:w-72">
                        <img
                            className="w-auto h-[200px] object-cover mx-auto border rounded-md"
                            src={idPhotoPreview}
                            alt="ID"
                        />
                    </div>
                </div>
            </div>

            <div className="mt-4">
                <h2 className="font-semibold">Kartu Pelanggan</h2>

                <div className="hidden xl:block mt-4">
                    <DataTable
                        columns={columns}
                        data={customerCardList?.data ?? []}
                    />
                </div>
            </div>

            <div className="mt-5 flex flex-wrap justify-end w-full gap-2">
                <BackButton onClick={backBtnClick}  />
            </div>
        </MainBodyCard>
    )
}